import { GET_ALL_SHORTLIST_DETAILS, GET_ALL_SHORTLIST_DETAILS_FAIL, GET_ALL_SHORTLIST_DETAILS_SUCCESS } from "./actionTypes";

export const getAllShortlistDetails = (requestData) => ({
    type: GET_ALL_SHORTLIST_DETAILS,
    payload: requestData
  });
  
  export const getAllShortlistDetailsSuccess = (data) => ({
    type: GET_ALL_SHORTLIST_DETAILS_SUCCESS,
    payload: data,
  });
  
  export const getAllShortlistDetailsFail = (error) => ({
    type: GET_ALL_SHORTLIST_DETAILS_FAIL,
    payload: error,
  });